import { SortResult } from "../../components/rank-sort/types";
import { RESPONSE_TYPE } from "../../const/vote";
import { IQuestionState } from "../../domain/ballot-state";
import { ApiIQuestion } from "../../domain/election";
import { QuestionValidationResult } from "../types";
import { REFEREDUM_VALUE } from "./types";

export type YesNoVote = REFEREDUM_VALUE | null | undefined;

export class YES_NO {
    static TYPE = RESPONSE_TYPE.YES_NO;
    static VERSION = "1.0.0";
    static INITIAL_VALUE = null
    static normalize = (questionState?: IQuestionState): YesNoVote => {
        if (!questionState) {
            return null;
        }
        const { response_type, data_version, value } = questionState;
        if (response_type !== YES_NO.TYPE) {
            return null
        }
        if (data_version !== YES_NO.VERSION) {
            return null;
        }
        if (!value || !Object.values(REFEREDUM_VALUE).includes(value)) {
            return null
        }
        return value;
    };
    static validate = (ballot: ApiIQuestion, vote: any): QuestionValidationResult => {
        if (vote === REFEREDUM_VALUE.YES || vote === REFEREDUM_VALUE.NO) {
            return { valid: true, empty: false }
        }
        return { valid: true, empty: true }
    }

    static prepare = (ballot: ApiIQuestion, vote: YesNoVote): YesNoVote => {
        return vote;
    };
}



export const sortPreferences = (a: SortResult, b: SortResult) => {
    if (a.index === null)
        return 1;
    if (b.index === null)
        return -1;
    return a.index > b.index ? 1 : -1
}
